/**
 * Labstep
 *
 * @module components/ShareLinkInvitation/Modal/ViewPendingInvites
 * @desc A modal showing ShareLinkInvitations
 */

import { ShareLinkInvitationListContainer as ShareLinkInvitationList } from 'labstep-web/components/ShareLinkInvitation/List';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { ShareLinkInvitation } from 'labstep-web/models/share-link-invitation.model';
import type React from 'react';
import type { IShareLinkInvitationModalViewPendingInvitesProps } from './types';

export const ShareLinkInvitationModalViewPendingInvites: React.FC<
  IShareLinkInvitationModalViewPendingInvitesProps
> = ({ entity }) => (
  <ReadOnMountHOC
    type="count"
    entityName={ShareLinkInvitation.entityName}
    params={{
      [`${entity.entityName}_id`]: entity.id,
      share_link_is_deleted: false,
    }}
  >
    {({ total }) => {
      if (total === 0) {
        return null;
      }
      return (
        <ModalDefault
          header="Pending invites"
          content={() => <ShareLinkInvitationList entity={entity} />}
          viewComponent={({ toggleModal }) => (
            <ActionComponent
              type="text"
              text="View pending invites"
              onClick={toggleModal}
            />
          )}
          showDone
        />
      );
    }}
  </ReadOnMountHOC>
);
